import { render, staticRenderFns } from "./BuilderGroup.vue?vue&type=template&id=a377946c&"
import script from "./BuilderGroup.vue?vue&type=script&lang=js&"
export * from "./BuilderGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports